<template>
  <v-container class="py-16 home-page text-center" style="max-width: 900px;" lang="ru">
    <h1 class="text-h4 mb-8">Мониторинг упоминаний в открытых источниках</h1>
    <v-btn color="primary" size="large" to="/signup">Регистрация</v-btn>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HomePage',
  computed: {
    ...mapState({
      isLoggedIn: state => state.isLoggedIn,
      authInitialized: state => state.authInitialized
    })
  },
  watch: {
    authInitialized: {
      immediate: true,
      handler(initialized) {
        if (initialized && this.isLoggedIn) {
          this.$router.push('/dashboard');
        }
      }
    }
  },
  mounted() {
    // Redirect to dashboard if already logged in
    if (this.authInitialized && this.isLoggedIn) {
      this.$router.push('/dashboard');
    }
  }
};
</script>
